<template>
  <div class="container">
    <div class="row">
      <div class="col">Round</div>
      <div class="col" v-for="player in players" :key="player.name">
        <span>{{player.name}}</span>
        <b-button v-if="completionType == 'PLAYER_OUT'" v-on:click="playerOut(player.name)" variant="outline" class="mb-2" size="sm" v-b-popover.hover="'Mark player out'" title=""><b-icon icon="box-arrow-in-right"></b-icon></b-button>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: "playerheader",
  props: {
    players: Array,
    completionType: String,
    gameId: String
  },
  methods: {
    playerOut(playerName) {
    /* eslint-disable no-console */
    console.log('player out ' + playerName)
    /* eslint-enable no-console */
      const data = {
        id: this.gameId,
        player: playerName,
      };
 
      this.$store.dispatch('game/playerOut', data)
    }
  }
};
</script>

<style scoped>
.container {
  display: flex; /* or inline-flex */
  flex-direction: column;
}

.row {
  display: flex; /* or inline-flex */
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: space-around;
  align-content: center;
  justify-content: space-between;
}
.row > * {
  flex: 1 100%;
}

.col {
  padding: 5px;
  
  line-height: 15px;
  font-weight: bold;
  font-size: 1.2em;
  text-align: center;
}

</style>